import type { Session } from '../Session.model';
import { useQuery } from '@tanstack/react-query';
import { User } from '../../types/User.model';
import { getIdentitySessionQuery } from '../Session.queries';
import { SESSION_GC_TIME, SESSION_STALE_TIME } from '../Session.constants';
import { useToken } from '../useToken';
import { useAuth0 } from '@auth0/auth0-react';

export const useSession = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}): Session => {
  const auth0Session = useAuth0();

  const token = useToken();

  const identity = useQuery<User | null>({
    ...getIdentitySessionQuery(token.data),
    enabled: enabled && !!token.data,
    staleTime: SESSION_STALE_TIME,
    cacheTime: SESSION_GC_TIME,
  });

  const auth0Loading = !auth0Session.isAuthenticated && auth0Session.isLoading;
  const tokenLoading = !token.data && token.isLoading;
  const identityLoading = !identity.data && identity.isLoading;

  const auth0Error = !auth0Session.user && !!auth0Session.error;
  const tokenError = !token.data && token.isError;
  const identityError = !identity.data && identity.isError;

  const isHumError =
    auth0Session.isAuthenticated && !!token.data && identityError;

  return {
    isLoading:
      auth0Loading ||
      (auth0Session.isAuthenticated && (tokenLoading || identityLoading)),
    isAuthenticated: auth0Session.isAuthenticated && !!identity.data,
    isError: auth0Error || tokenError || identityError,
    isHumError,
    token: token,
    user: identity.data,
  };
};
